/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 7th 2022, 1:29:24 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export interface APIErrorState {
  isAPIError: boolean;
  apiErrors: { non_field_errors?: string[]; detail?: string; [key: string]: any };
}

export interface APIRequestState {
  isMakingAPIRequest: boolean;
  isSuccessfulAPIRequest: boolean;
  apiErrorState: APIErrorState;
  apiRequestCount: number;
  httpResponseStatusCode: number;
}

export enum STATUS_CODES {
  OK = 200,
  UnreachableServerErrorCode = 8000,
  ClientError = 400,
  Unauthorized = 401,
  PermissionDenied = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  ClientClosedRequest = 499,
  ServerError = 500,
  NetworkConnectTimeout = 599,
}
